export default "__VITE_ASSET__DpEUMdZu__"